import { render, staticRenderFns } from "./catch-all.vue?vue&type=template&id=0c0e9fee&scoped=true"
import script from "./catch-all.vue?vue&type=script&lang=js"
export * from "./catch-all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e9fee",
  null
  
)

export default component.exports